import "./styles.sass";

import React, { FC } from "react";
import { ReactComponent as CloseIcon } from "../../assets/icons/close-circle.svg";
import Button from "../UI/button/GgButton";

interface IModal {
  show: boolean;
  children: any;
  onClose: (state: boolean) => void;
  title?: string;
  size?: {
    width?: number | string;
    height?: number | string;
  };
  showSubmit?: boolean;
  onSubmit?: () => void;
  submitLabel?: string;
}

const Modal: FC<IModal> = ({
  show,
  children,
  onClose,
  size,
  title,
  showSubmit,
  onSubmit,
  submitLabel,
}) => {
  return (
    <>
      {show && (
        <div className={`modal show`}>
          <div className="background" onClick={() => onClose(false)} />
          <div
            className="modal-container nav"
            style={{ width: "100%", height: "100%" }}
          >
            <div className="tool-top-panel">
              <span className="tool-top-panel-item title">
                {title ? title : ""}
              </span>
              <span className="tool-top-panel-item close">
                {showSubmit && (
                  <Button label={submitLabel || "Save"} onPress={onSubmit} />
                )}
                <CloseIcon onClick={() => onClose(false)} className="icon" />
              </span>
            </div>
            <div className="modal-body" style={{ marginTop: "10px" }} >
              <div style={{ width: "100%", height: "100%", overflowY: "scroll", paddingRight: "20px" }}>
              {children}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
